import axios from 'axios';

import { URL_ENDPOINT } from '../../../index';

import {
	ADD_MAIN_CATEGORY,
	GET_ALL_CATEGORIES,

	REMOVE_MAIN_CATEGORY,
	REMOVE_SUB_CATEGORY,

	UPDATE_CATEGORY,
	UPDATE_CATEGORY_TITLE,
	UPDATE_GOOGLE_TAXONOMY,
	UPDATE_SUB_CATEGORY_IMAGE,
	UPDATE_SUB_CATEGORY_TITLE
} from './types';

export const getAllCategories = () => ({
	type: GET_ALL_CATEGORIES,
	payload: axios({
		withCredentials: true,
		url: `${URL_ENDPOINT}/api/category`
	})
})

export const addMainCategory = ( category ) => ({
	type: ADD_MAIN_CATEGORY,
	category
})

export const addMainTitle = (title) => axios({
	data: { title },
	url: `${URL_ENDPOINT}/api/category/new`,
	method: 'post',
	withCredentials: true
})

export const addSubTitle = (_id, title) => axios({
	data: { title },
	url: `${URL_ENDPOINT}/api/category/new/${_id}`,
	method: 'post',
	withCredentials: true
})

export const removeMainCategory = ({ mainCategory }) => ({
	type: REMOVE_MAIN_CATEGORY,
	mainCategory
})

export const removeSubCategory = ({ mainCategory, subCategory }) => ({
	type: REMOVE_SUB_CATEGORY,
	mainCategory, 
	subCategory
})

export const updateCategory = ( category ) => ({
	type: UPDATE_CATEGORY,
	category
})

export const updateGoogleTaxonomy = ({ mainIndex, subIndex, googleTaxonomy }) => ({
	type: UPDATE_GOOGLE_TAXONOMY,
	googleTaxonomy,
	mainIndex, 
	subIndex
});

export const updateSubCategoryImage = ({mainIndex, subIndex, value}) => ({
	type: UPDATE_SUB_CATEGORY_IMAGE,
	mainIndex,
	subIndex,
	value
})




// WEBPACK FOOTER //
// ./src/components/category/actions/index.js